// src/pages/Authentication/ChangePassword/validationSchema.ts
// Yup validation schema for change password form

import * as Yup from 'yup';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('authentication');

export const changePasswordSchema = Yup.object().shape({
  currentPassword: Yup.string()
    .required(st('vui_long_nhap_mat_khau_hien_error')),

  newPassword: Yup.string()
    .required(st('vui_long_nhap_mat_khau_moi_error'))
    .min(8, st('mat_khau_phai_co_it_nhat_error'))
    .matches(
      /[A-Z]/,
      st('mat_khau_phai_co_it_nhat_error_2')
    )
    .matches(
      /[0-9]/,
      st('mat_khau_phai_co_it_nhat_error_3')
    )
    .matches(
      /[!@#$%^&*(),.?":{}|<>]/,
      st('mat_khau_phai_co_it_nhat_error_4')
    )
    .test(
      'not-same-as-current',
      st('mat_khau_moi_phai_khac_mat_error'),
      function (value) {
        return value !== this.parent.currentPassword;
      }
    ),

  confirmPassword: Yup.string()
    .required(st('vui_long_xac_nhan_mat_khau_error'))
    .oneOf(
      [Yup.ref('newPassword')],
      st('mat_khau_xac_nhan_khong_khop_error')
    ),
});